import {UIEvents, useInjection} from "@dp-instant/ui";
import {IEventEmitter, TypesCore} from "@dp-instant/interfaces";
import {PopupType} from "@game/ui/PopupType";
import {playUIClickSound} from "@game/helpers";
import {hapticMedium} from "@game/haptic";
import {useState, useEffect} from "preact/hooks";
import {getOfferConfig, clearOffer} from "@game/ui/popups/StarterOfferPopup";
import {apiClient} from "@game/api/ApiClient";
import "./StarterOfferButton.less";

const LS_KEY_EXPIRES = "sio_starter_offer_expires";

function getRemaining(): number {
    try {
        const exp = parseInt(localStorage.getItem(LS_KEY_EXPIRES) || "0");
        if (!exp) return 0;
        return Math.max(0, Math.floor((exp - Date.now()) / 1000));
    } catch { return 0; }
}

function fmtShort(sec: number): string {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
}

export const StarterOfferButton = () => {
    const dispatcher = useInjection<IEventEmitter>(TypesCore.dispatcher);
    const [remaining, setRemaining] = useState(0);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Verify with server on mount
        apiClient.getStarterOffer().then(config => {
            if (!config.enabled) {
                clearOffer();
                setVisible(false);
            }
        }).catch(() => {});

        const check = () => {
            const r = getRemaining();
            const config = getOfferConfig();
            if (r <= 0 || !config) {
                setVisible(false);
                if (r <= 0) clearOffer();
                return;
            }
            setRemaining(r);
            setVisible(true);
        };
        check();
        const id = setInterval(check, 1000);
        return () => clearInterval(id);
    }, []);

    if (!visible) return null;

    const onClick = () => {
        playUIClickSound();
        hapticMedium();
        const config = getOfferConfig();
        if (!config) return;
        // Always open from the main pack offer (or upsell if pack already bought — server decides via config.step)
        const openStep = config.step || "pack";
        dispatcher.emit(UIEvents.POPUP, {
            id: PopupType.STARTER_OFFER,
            props: { config, onDone: () => {}, initialStep: openStep }
        });
    };

    return (
        <div className="starter-offer-btn" onClick={onClick}>
            <div className="starter-offer-btn__icon">{"🎁"}</div>
            <div className="starter-offer-btn__badge">{fmtShort(remaining)}</div>
        </div>
    );
};
